const utils = (context) => {
  const { current } = context;
  return {};
};

const main = (context) => {
  const { dispatch } = context;
  return {
    reloadCorners() {
      setTimeout(() => {
        dispatch("corners/loadTables", null, { root: true });
        dispatch("corners/loadCorners", null, { root: true });
      }, 0);
      // Undo Operation
      return async () => {
        setTimeout(() => {
          dispatch("corners/loadTables", null, { root: true });
          dispatch("corners/loadCorners", null, { root: true });
        }, 0);
      };
    },
  };
};

export default (context) => {
  return {
    main: main(context),
    utils: utils(context),
  };
};
